// This file is generated automatically by `scripts/build/fp.ts`. Please, don't change it.

import { startOfWeekYear as fn } from "../startOfWeekYear.js";
import { convertToFP } from "./_lib/convertToFP.js";

export const startOfWeekYearWithOptions = convertToFP(fn, 2);

// Fallback for modularized imports:
export default startOfWeekYearWithOptions;
